// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { BuildAssemblyDetail } from './build-assembly-detail';
import { BuildAssemblyStatus } from './build-assembly-status';
import { PurchaseOrder } from './purchase-order';
import { Vendor } from './vendor';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class BuildAssembly extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Statuses = {
        New: 1,
        Submitted: 2,
        Complete: 3,
        Error: 4,
    };
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  buildDate!: Date;
  buildNumber!: number;
  createDate!: Date;
  createPO!: boolean;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  notes?: string;
  purchaseOrderId?: number;
  shipToId?: number;
  statusId!: number;
  vendorId?: number;
  details!: BuildAssemblyDetail[];
  purchaseOrder!: PurchaseOrder;
  status!: BuildAssemblyStatus;
  vendor!: Vendor;
}

